module.exports = __webpack_public_path__ + "img/new_07_1.5c8e5bcd.jpg";